module.exports = __webpack_public_path__ + "files/7c04c4cc73f15537f98b82b15f752334.png";